import { createContext, useContext, useEffect, useState } from "react";
import { Validations } from "@/utils/validations";
import { PrivilegeContext } from "@/context/PrivilegesContext";
import { USER_ACTIONS } from "@/data/Constant";

const HomeContext = createContext();

const HomeProvider = ({ children }) => {
  const [loading, setLoading] = useState(true);
  const [havePermission, setHavePermission] = useState(false);
  const { privileges, userRoleId, userName, isSuperAdmin, isLoggedIn, userId, roleName, authorizedPages } = useContext(PrivilegeContext);

const hasPermission = (controllerId) => {
  if (isSuperAdmin) return true;

  const page = authorizedPages?.find(
    (item) => item.id === controllerId
  );

  if (!page?.privileges) return false;

  return !!page.privileges[USER_ACTIONS.GET];
};

useEffect(() => {

console.log("privileges : ", authorizedPages)
}, [authorizedPages])

  
  const checkNullEmpty = (val) => {
    return (
      Validations.isNull(val) ||
      Validations.isArrayEmpty(val) ||
      Validations.isUndefined(val)
    );
  };

  const renderedCols = (items) => {
    const truthyCount = items.filter((item) => item).length;
    if (truthyCount === 0) {
      return "cols-1";
    } else if (truthyCount === items.length) {
      return `cols-${items.length}`;
    } else if (truthyCount > 0) {
      return `cols-${truthyCount}`;
    }
  };
  const value = {
    loading,
    checkNullEmpty,
    hasPermission,
    renderedCols,
  };

  return <HomeContext.Provider value={value}>{children}</HomeContext.Provider>;
};

export default HomeProvider;

export const useHome = () => {
  const context = useContext(HomeContext);
  if (!context) {
    throw new Error("useHome must be used within HomeProvider");
  }
  return context;
};
